import React from "react";

import { CARD_CONTAINER_ID } from "@comparaonline/ui-offer-card-list";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";

const styles = ({ breakpoints, palette }: Theme) => ({
  root: {
    [breakpoints.down("xs")]: {
      [`& div[data-id|=${CARD_CONTAINER_ID}]`]: {
        "&:first-child": {
          paddingTop: 0
        },
        "&:last-child": {
          paddingBottom: 0
        }
      },
      backgroundColor: palette.grey["100"]
    }
  }
});

type IProps = WithStyles<typeof styles>;

const ContainerBase: React.FC<IProps> = ({ classes, children }) => (
  <div className={classes.root}>{children}</div>
);

export const Container = withStyles(styles)(ContainerBase);
